import {view} from '@sail/ui';
import {defineMessages, FormattedMessage} from 'react-intl';
import {MetaRow} from './MetaRow';

const messages = defineMessages({
  chatEnded: {
    id: 'conversations_ui.chat.row.chatEnded.status',
    description: 'Message to show to indicate the chat has ended',
    defaultMessage: 'The chat has ended.',
  },
});

type Props = {
  MetaRowComponent?: typeof MetaRow;
};

export const ChatEndedRow = ({MetaRowComponent = MetaRow}: Props) => (
  <view.div
    data-testid="chat-ended-row"
    className="uh-conversations-contains-meta-row"
  >
    <MetaRowComponent>
      <FormattedMessage {...messages.chatEnded} />
    </MetaRowComponent>
  </view.div>
);
